import AssistantMessageCopyFeedbackActions from './AssistantMessageCopyFeedbackActions'
import AssistantMessageMenuTriggerActions from './AssistantMessageMenuTriggerActions'

export default function AssistantMessageFeedbackActions(props) {
  return (
    <>
      <AssistantMessageCopyFeedbackActions {...props} />
      <AssistantMessageMenuTriggerActions {...props} />
    </>
  )
}
